// extracted by mini-css-extract-plugin
export default {"price":"styles-module__price__src-labstep-web-components-OrderRequest-Price-_kJmJE"};